module.exports = __webpack_public_path__ + "static/media/step-indicator-2.ae83abb6.svg";